// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2P5Z-","right":"Footer_right__85N49","buttons":"Footer_buttons__1pP_B"};